export default class AlternadorDespliegue {
    constructor(boton) {
        this.boton = boton;
        this.elementos = [];
        this.configurar();
    }

    configurar() {
        const elementosIds = this.boton.getAttribute("aria-controls").split(" "),
                estaPresionado = this.boton.getAttribute("aria-expanded") === "true";
        for (const elementoId of elementosIds) {
            this.elementos.push(document.getElementById(elementoId));
        }
        this.alternarVisibilidad = this.botonClickCallback();
        this.boton.addEventListener("click", this.alternarVisibilidad);
        this.alternarElementos(estaPresionado);
    }

    alternarElementos(estaPresionado) {
        for (const elemento of this.elementos) {
            if (estaPresionado) {
                elemento.classList.remove("no-desplegar");
            } else {
                elemento.classList.add("no-desplegar");
            }
        }
    }

    botonClickCallback() {
        return (event) => {
            const {currentTarget} = event,
            estaPresionado = (currentTarget.getAttribute("aria-expanded") === "true");

            currentTarget.setAttribute("aria-expanded", estaPresionado ? "false" : "true");
            this.alternarElementos(!estaPresionado);
        };
    }
}